import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import { Container, Navbar, Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom"; // <-- Import useLocation
import axios from "axios";
import { BASE_URL } from "../Config";

const Admin_Header = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // <-- Get current path
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) setUserData(user);
  }, []);

  const handleLogout = () => {
    handleLogOutApi();
  };

  const handleLogOutApi = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}Retail_Logout`,
        { userId: userData?.userId },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "0000") {
        logout();
        sessionStorage.removeItem("user");
        navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // Helper: check if current path matches
  const isActive = (path) => location.pathname === path;

  return (
    <Navbar expand="lg" className="bg-body-tertiary" style={{ borderRadius: "25px" }}>
      <Container>
        <Navbar.Brand href={`/Admin/Admin_Dashboard`}>
          <img src="../Webdoc_Logo.webp" style={{ width: "90px" }} alt="logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="w-100 me-auto">
            {userData ? (
              <>
                <Nav.Link href="/Admin/Admin_Dashboard" className={isActive("/Company/Company_Dashboard") ? "fw-bold" : ""}>
                  Dashboard
                </Nav.Link>
                <Nav.Link href="/Company/Company_Report" className={isActive("/Company/Company_Report") ? "fw-bold" : ""}>
                  Report
                </Nav.Link>
                <Nav.Link href="/Company/Company_Team" className={isActive("/Company/Company_Team") ? "fw-bold" : ""}>
                  Agents
                </Nav.Link>
                <Nav.Link href="/Company/CompanyPackage" className={isActive("/Company/CompanyPackage") ? "fw-bold" : ""}>
                  Package
                </Nav.Link>
                <Nav.Link href="/Company/Agent_AssignPkgs" className={isActive("/Company/Agent_AssignPkgs") ? "fw-bold" : ""}>
                  Agent Packages
                </Nav.Link>

                <div className="d-flex ms-auto">
                  <Nav.Link className="text-end">{userData?.name}</Nav.Link>
                  <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
                </div>
              </>
            ) : (
              <Nav.Link href="/">Login</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Admin_Header;
